export interface Pet {
  name: string;
  type: string;
  breed: string;
  age: string;
}

export class PetService {
  private readonly STORAGE_KEY = 'savedPets';

  public savePet(pet: Pet): void {
    const pets = this.getSavedPets();
    pets.push(pet);
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(pets));
  }

  public getSavedPets(): Pet[] {
    const petsJson = localStorage.getItem(this.STORAGE_KEY);
    return petsJson ? JSON.parse(petsJson) : [];
  }

  public clearPets(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}

